import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'IssueFormAdditionalPersonalDataController',
            IssueFormAdditionalPersonalDataController
        );

    function IssueFormAdditionalPersonalDataController() {}
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/additional_personal_data/issue_form_description.controller.ts